import React from "react";
import ReactApexChart from "react-apexcharts";

import "../../components/Unique/Login/login_form.css";
import LoginForm from "../../components/Unique/Login/login_form"; // Importing LoginForm component
import PageHeader from "../../components/Page/page_header"; // Importing PageHeader component
import { useEffect, useState, useRef } from "react"; // Importing React hooks
import { useSidebar } from "../../components/ui/sidebar"; // Context for managing sidebar state
import logo from "./../../components/Assets/denda white.png"; // Importing logo image
import "./home.css"; // Importing specific styles for Home page
import { useMediaQuery } from "@mui/material";
import LoginPage from "../../pages/MobileView/LoginPage";
import CountAnimation from "../../components/Unique/Animation/Count-up.tsx";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "../../components/ui/chart";

import { Area, AreaChart, CartesianGrid, XAxis } from "recharts";

const Home = () => {
  const percentageRef = useRef(null);
  const isMobile = useMediaQuery(`(max-width:768px)`);
  const { mode } = useSidebar();

  const hasSubsidiaries = true;
  const brandNames = ["BrandA", "BrandB", "BrandC"];
  const brandValues = [230, 180, 95];

  const chartData = [
    { date: "2024-04-01", desktop: 222, mobile: 150 },
    { date: "2024-04-02", desktop: 97, mobile: 180 },
    { date: "2024-04-03", desktop: 167, mobile: 120 },
    { date: "2024-04-04", desktop: 242, mobile: 260 },
    { date: "2024-04-05", desktop: 373, mobile: 290 },
    { date: "2024-04-06", desktop: 301, mobile: 340 },
    { date: "2024-04-07", desktop: 245, mobile: 180 },
    { date: "2024-04-08", desktop: 409, mobile: 320 },
    { date: "2024-04-09", desktop: 59, mobile: 110 },
    { date: "2024-04-10", desktop: 261, mobile: 190 },
    { date: "2024-04-11", desktop: 327, mobile: 350 },
    { date: "2024-04-12", desktop: 292, mobile: 210 },
    { date: "2024-04-13", desktop: 342, mobile: 380 },
    { date: "2024-04-14", desktop: 137, mobile: 220 },
    { date: "2024-04-15", desktop: 120, mobile: 170 },
    { date: "2024-04-16", desktop: 138, mobile: 190 },
    { date: "2024-04-17", desktop: 446, mobile: 360 },
    { date: "2024-04-18", desktop: 364, mobile: 410 },
    { date: "2024-04-19", desktop: 243, mobile: 180 },
    { date: "2024-04-20", desktop: 89, mobile: 150 },
    { date: "2024-04-21", desktop: 137, mobile: 200 },
    { date: "2024-04-22", desktop: 224, mobile: 170 },
    { date: "2024-04-23", desktop: 138, mobile: 230 },
    { date: "2024-04-24", desktop: 387, mobile: 290 },
    { date: "2024-04-25", desktop: 215, mobile: 250 },
    { date: "2024-04-26", desktop: 75, mobile: 130 },
    { date: "2024-04-27", desktop: 383, mobile: 420 },
    { date: "2024-04-28", desktop: 122, mobile: 180 },
    { date: "2024-04-29", desktop: 315, mobile: 240 },
    { date: "2024-04-30", desktop: 454, mobile: 380 },
    { date: "2024-05-01", desktop: 165, mobile: 220 },
    { date: "2024-05-02", desktop: 293, mobile: 310 },
    { date: "2024-05-03", desktop: 247, mobile: 190 },
    { date: "2024-05-04", desktop: 385, mobile: 420 },
    { date: "2024-05-05", desktop: 481, mobile: 390 },
    { date: "2024-05-06", desktop: 498, mobile: 520 },
    { date: "2024-05-07", desktop: 388, mobile: 300 },
    { date: "2024-05-08", desktop: 149, mobile: 210 },
    { date: "2024-05-09", desktop: 227, mobile: 180 },
    { date: "2024-05-10", desktop: 293, mobile: 330 },
    { date: "2024-05-11", desktop: 335, mobile: 270 },
    { date: "2024-05-12", desktop: 197, mobile: 240 },
    { date: "2024-05-13", desktop: 197, mobile: 160 },
    { date: "2024-05-14", desktop: 448, mobile: 490 },
    { date: "2024-05-15", desktop: 473, mobile: 380 },
    { date: "2024-05-16", desktop: 338, mobile: 400 },
    { date: "2024-05-17", desktop: 499, mobile: 420 },
    { date: "2024-05-18", desktop: 315, mobile: 350 },
    { date: "2024-05-19", desktop: 235, mobile: 180 },
    { date: "2024-05-20", desktop: 177, mobile: 230 },
    { date: "2024-05-21", desktop: 82, mobile: 140 },
    { date: "2024-05-22", desktop: 81, mobile: 120 },
    { date: "2024-05-23", desktop: 252, mobile: 290 },
    { date: "2024-05-24", desktop: 294, mobile: 220 },
    { date: "2024-05-25", desktop: 201, mobile: 250 },
    { date: "2024-05-26", desktop: 213, mobile: 170 },
    { date: "2024-05-27", desktop: 420, mobile: 460 },
    { date: "2024-05-28", desktop: 233, mobile: 190 },
    { date: "2024-05-29", desktop: 78, mobile: 130 },
    { date: "2024-05-30", desktop: 340, mobile: 280 },
    { date: "2024-05-31", desktop: 178, mobile: 230 },
    { date: "2024-06-01", desktop: 178, mobile: 200 },
    { date: "2024-06-02", desktop: 470, mobile: 410 },
    { date: "2024-06-03", desktop: 103, mobile: 160 },
    { date: "2024-06-04", desktop: 439, mobile: 380 },
    { date: "2024-06-05", desktop: 88, mobile: 140 },
    { date: "2024-06-06", desktop: 294, mobile: 250 },
    { date: "2024-06-07", desktop: 323, mobile: 370 },
    { date: "2024-06-08", desktop: 385, mobile: 320 },
    { date: "2024-06-09", desktop: 438, mobile: 480 },
    { date: "2024-06-10", desktop: 155, mobile: 200 },
    { date: "2024-06-11", desktop: 92, mobile: 150 },
    { date: "2024-06-12", desktop: 492, mobile: 420 },
    { date: "2024-06-13", desktop: 81, mobile: 130 },
    { date: "2024-06-14", desktop: 426, mobile: 380 },
    { date: "2024-06-15", desktop: 307, mobile: 350 },
    { date: "2024-06-16", desktop: 371, mobile: 310 },
    { date: "2024-06-17", desktop: 475, mobile: 520 },
    { date: "2024-06-18", desktop: 107, mobile: 170 },
    { date: "2024-06-19", desktop: 341, mobile: 290 },
    { date: "2024-06-20", desktop: 408, mobile: 450 },
    { date: "2024-06-21", desktop: 169, mobile: 210 },
    { date: "2024-06-22", desktop: 317, mobile: 270 },
    { date: "2024-06-23", desktop: 480, mobile: 530 },
    { date: "2024-06-24", desktop: 132, mobile: 180 },
    { date: "2024-06-25", desktop: 141, mobile: 190 },
    { date: "2024-06-26", desktop: 434, mobile: 380 },
    { date: "2024-06-27", desktop: 448, mobile: 490 },
    { date: "2024-06-28", desktop: 149, mobile: 200 },
    { date: "2024-06-29", desktop: 103, mobile: 160 },
    { date: "2024-06-30", desktop: 446, mobile: 400 },
  ];

  const timeRangeOptions = [
    { value: "90d", label: "3 months" },
    { value: "30d", label: "30 days" },
    { value: "7d", label: "7 days" },
  ];

  const chartConfig = {
    desktop: {
      label: "Desktop",
      color: "#2563eb",
    },
    mobile: {
      label: "Mobile",
      color: "#60a5fa",
    },
  };

  // const pageNames =  Object.keys(structuredPages).map();

  function Timeline() {
    return (
      <div className={` timeline `}>
        <select className={`timeline-selector ${mode === "light" ? "" : "dark"} `}>
          <option value="1">Today</option>
          <option value="2">Yesterday</option>
          <option value="2">Last 7 Days</option>
          <option value="2">Last Month</option>
          <option value="3">Year to Date</option>
        </select>
      </div>
    );
  }

  function Metrics() {
    return (
      <div className={`timeline `}>
        <select className={`timeline-selector ${mode === "light" ? "" : "dark"} `}>
          <option value="1"> Active Players</option>
          <option value="2"> Ad Impressions</option>
          <option value="2"> Return Visits</option>
          {/*<option value="2">Last Month</option>*/}
          {/*<option value="3">Year to Date</option>*/}
        </select>
      </div>
    );
  }

  function DateRange() {
    return (
      <div className={`timeline`}>
        <select className={`timeline-selector ${mode === "light" ? "" : "dark"}`} value={timeRange} onChange={handleTimeRangeChange}>
          {timeRangeOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  }

  function BrandBreakdownChart({ brandNames, brandValues, gameName }) {
    // Generate dynamic series data based on props
    const series = brandNames.map((brand, index) => ({
      name: brand,
      data: [brandValues[index]],
    }));

    // Chart options configuration
    const chartOptions = {
      chart: {
        type: "bar",
        height: 150,
        stacked: true,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "100%", // Makes the bar height fit the graph area
          columnWidth: "100%", // Adjusts the width to remove spaces
          distributed: false, // Ensures the bar is not broken into segments
          dataLabels: {
            total: {
              enabled: true,
              offsetX: 0,
              style: {
                fontSize: "13px",
                fontWeight: 900,
              },
            },
          },
        },
      },
      stroke: {
        width: 1,
        colors: ["#fff"],
      },
      // title: {
      //     text: `${gameName} Brand Breakdown`,
      // },
      // xaxis: {
      //     categories: [gameName],
      // },
      yaxis: {
        show: false,
      },
      fill: {
        opacity: 1,
      },
      legend: {
        show: false,
      },
    };

    return (
      <div className="brand-breakdown-chart" style={{ width: "100%" }}>
        <ReactApexChart
          options={chartOptions} // Pass options
          series={series} // Pass dynamic series here
          type="bar"
          height={100}
        />
      </div>
    );
  }

  function Kpi({ children, header, number, percentage }) {
    return (
      <div className={`kpi ${mode === "light" ? "lightr" : "darkr"} shadow-md`}>
        <div className="kpi-header">
          <div>
            <span>{header}</span>
          </div>
          <Timeline />
        </div>

        <div className={`kpi-body ${mode === "light" ? "" : "dark"}`}>
          {/* Use CountAnimation for the main KPI number */}
          <CountAnimation number={number} className="number" />

          <h5>
            <div className={`percentage ${percentage >= 0 ? "green" : "red"}`} ref={percentageRef}>
              {percentage > 0 ? `+${percentage.toFixed(2)}%` : `${percentage.toFixed(2)}%`}
            </div>
          </h5>

          {children}
        </div>
      </div>
    );
  }

  function Games({ children, header }) {
    return (
      <div className={`topg ${mode === "light" ? "lightr" : "darkr"} shadow-md`}>
        <div className={`games-header`}>
          <h4> {header} </h4>
          <Metrics />
        </div>

        {/*<Divider className="games-divider"/>*/}
        <div className={`games-body ${mode === "light" ? "" : "dark"} `}> {children} </div>
      </div>
    );
  }

  // States for controlling the visibility of welcome message and login form
  const [showWelcome, setShowWelcome] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);

  // Getting the authentication and sidebar functions from context
  const { authenticated, setSidebarOpen, toggleMobileSidebar } = useSidebar();

  const [timeRange, setTimeRange] = React.useState("90d");
  const filteredData = chartData.filter((item) => {
    const date = new Date(item.date);
    const referenceDate = new Date("2024-06-30");
    let daysToSubtract = 90;
    if (timeRange === "30d") {
      daysToSubtract = 30;
    } else if (timeRange === "7d") {
      daysToSubtract = 7;
    }
    const startDate = new Date(referenceDate);
    startDate.setDate(startDate.getDate() - daysToSubtract);
    return date >= startDate;
  });

  // useEffect to trigger animations on component mount
  useEffect(() => {
    // Show welcome message when component mounts
    setShowWelcome(true);

    // Delay showing the login form for animation effect
    const timer = setTimeout(() => setShowLoginForm(true), 500); // Adjusting the delay for the form

    // Clear the timer when the component is unmounted
    return () => clearTimeout(timer);
  }, []);

  // useEffect to handle authentication changes
  useEffect(() => {
    if (authenticated) {
      // Hide welcome message and login form if authenticated
      setShowWelcome(false);
      setShowLoginForm(false);
      setSidebarOpen(true); // Open sidebar when user is authenticated
    } else {
      // Show welcome message and login form if not authenticated
      setShowWelcome(true);
      setShowLoginForm(true);
    }
  }, [authenticated, setSidebarOpen]); // Effect runs when authentication state or sidebar state changes

  // useEffect(() => {
  //     const container = document.querySelector(".kpi-container");
  //     if (container) {
  //         container.scrollLeft = 0; // Jump to the far left
  //     }
  // }, []);

  const handleTimeRangeChange = (event) => {
    setTimeRange(event.target.value);
  };

  return (
    <div className="home">
      {/* Controlling overflow behavior of the home page */}
      {authenticated ? ( // Check if the user is authenticated
        <>
          {/* Show different background images based on screen size */}
          {/*<img className="hide-mobile background-image" src={stonks_mini}*/}
          {/*     alt="Stonks"/> /!* Display only on desktop *!/*/}

          <div className={"default_page_style"}>
            <PageHeader title="Home" toggleSidebar={toggleMobileSidebar} /> {/* Render page header and toggle sidebar */}
            <div className="kpi-container">
              <Kpi header={"New Players"} number={572} percentage={-3.19} />
              <Kpi header={"Total Players"} number={1738} percentage={+5.25} />
              <Kpi header={"Gameplays"} number={12310} percentage={+3.19} />
              <Kpi header={"Avg Gameplays"} number={335} percentage={+9.43} />
              <Kpi header={"Ads"} number={7437} percentage={+1.02} />
            </div>
            <div className="dashb-container">
              <div className="dashb">
                <Card>
                  <CardHeader className="flex items-center gap-2 space-y-0 border-b py-5 sm:flex-row">
                    <div className="grid flex-1 gap-1 text-center sm:text-left">
                      <CardTitle>Gameplay Statistics</CardTitle>
                      <CardDescription>Showing total gameplays for the selected date range</CardDescription>
                    </div>
                    <DateRange timeRange={timeRange} setTimeRange={setTimeRange} />
                  </CardHeader>
                  <CardContent className="px-2 pt-4 sm:px-6 sm:pt-6">
                    <ChartContainer config={chartConfig} className="aspect-auto h-[250px] w-full">
                      <AreaChart data={filteredData}>
                        <defs>
                          <linearGradient id="fillDesktop" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="var(--color-desktop)" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="var(--color-desktop)" stopOpacity={0.1} />
                          </linearGradient>
                          <linearGradient id="fillMobile" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="var(--color-mobile)" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="var(--color-mobile)" stopOpacity={0.1} />
                          </linearGradient>
                        </defs>
                        <CartesianGrid vertical={false} />
                        <XAxis
                          dataKey="date"
                          tickLine={false}
                          axisLine={false}
                          tickMargin={8}
                          minTickGap={32}
                          tickFormatter={(value) => {
                            const date = new Date(value);
                            return date.toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                            });
                          }}
                        />
                        <ChartTooltip
                          cursor={false}
                          content={
                            <ChartTooltipContent
                              labelFormatter={(value) => {
                                return new Date(value).toLocaleDateString("en-US", {
                                  month: "short",
                                  day: "numeric",
                                });
                              }}
                              indicator="dot"
                            />
                          }
                        />
                        <Area dataKey="mobile" type="natural" fill="url(#fillMobile)" stroke="var(--color-mobile)" stackId="a" />
                        <Area dataKey="desktop" type="natural" fill="url(#fillDesktop)" stroke="var(--color-desktop)" stackId="a" />
                      </AreaChart>
                    </ChartContainer>
                  </CardContent>
                </Card>
              </div>
            </div>
            {/*<Graph/>*/}
            {/*<div className = "games">*/}
            <div className="topg-container">
              {/*<Swiper spaceBetween={30} slidesPerView={1}>*/}
              {/*<SwiperSlide>*/}
              <Games header={"Top Games"}>
                <ul className="game-list">
                  <li>
                    <div className={`game-item ${mode === "light" ? "lightr" : "darkr"} `}>
                      <h6>Sudoblock</h6>
                      {/* If the client has subsidiaries, show the bar chart */}
                      {hasSubsidiaries && <BrandBreakdownChart brandNames={brandNames} brandValues={brandValues} gameName="Sudoblock" />}
                    </div>
                  </li>
                </ul>
              </Games>
              {/*</SwiperSlide>*/}
              {/*<SwiperSlide>*/}
              <Games header={"Bottom Games"}>
                <ul className="game-list">
                  <li>
                    <div className="game-item">
                      <h3>Some Other Game</h3>
                      {hasSubsidiaries && <BrandBreakdownChart brandNames={brandNames} brandValues={brandValues} gameName="Sudoblock" />}
                    </div>
                  </li>
                </ul>
              </Games>
              {/*</SwiperSlide>*/}
              {/*</Swiper>*/}
            </div>
          </div>
          {/*</div>*/}
        </>
      ) : // If not authenticated, show login form

      isMobile ? (
        <LoginPage />
      ) : (
        <div className="login-page">
          <div className="section1">
            {/* New container */}
            <div className="denda">
              <h4> Denda </h4>
            </div>
            <div className="login-logo">
              <img src={logo} alt="Logo" className="logo" /> {/* Display company logo */}
            </div>
            {showWelcome && ( // Show welcome message before login form
              <div className="welcome-message-login">
                <h4 className=" "> Welcome to the Denda Content Management Console </h4>
              </div>
            )}
          </div>
          <div className="section2">
            {showLoginForm && ( // Show login form after animation delay
              <>
                <span className="log-in"> Log In </span>
                <div className="login-form">
                  <LoginForm /> {/* Render LoginForm component */}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
